module.exports = __webpack_public_path__ + "img/french.73765dbc.svg";